import { CountryRequestData } from 'api/travel-request-detail';
import { autoinject, computedFrom } from 'aurelia-framework';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { CountryRequest, produceCountryApproval } from 'model/forms/travel-request';
import { aprovalRequired, SafetyService } from 'services/safety-service';
import { WidgetBase } from 'support/base_classes/widget-base';

@autoinject
export class CountryRequestWidget extends WidgetBase<CountryRequest | CountryRequestData, WidgetController> {
  constructor(private safety: SafetyService) {
    super();
  }

  @computedFrom('model.country.formFlag')
  get widgetIcon() {
    return this.model.country.formFlag ?? 'fas fa-globe-africa';
  }

  @computedFrom('model.approvalLevel')
  get countryGroupLabel() {
    return this.model.approvalLevel.name + (this.model.approvalLevel.description != null ? `: ${this.model.approvalLevel.description}` : '');
  }

  @computedFrom('model.approvalRequirementValue', 'model.transit')
  get approvalRequired() {
    return aprovalRequired(this.model.approvalRequirementValue, this.model.transit);
  }

  @watch((x: CountryRequestWidget) => x.approvalRequired)
  private approvalRequiredChanged(approvalRequired: boolean) {
    this.model.approval = approvalRequired ? produceCountryApproval(this.safety.countrySettings.get(this.model.country.id)) : null;
  }
}
